import {
  DiscountsQuery,
  DiscountsQueryEmptyState,
  DiscountsQueryList,
  DiscountsQueryProvider,
  useDiscountsQuery,
} from '@airship-platform/airship-proposal';
import { FlexBox } from '@airship-platform/jam-web/components';
import Typography from '@mui/material/Typography';
import AddDiscountButton from './AddDiscountButton';

const DiscountsQueryContent: React.FC = () => {
  const { searchTerm, discountsFiltered } = useDiscountsQuery();

  return (
    <FlexBox flexDirection={'column'} gap={2} width={'100%'}>
      <DiscountsQuery>
        <DiscountsQueryEmptyState
          searchTerm={searchTerm}
          isVisible={!discountsFiltered.length}
        />

        <Typography variant="body2">
          {discountsFiltered.length} results found
        </Typography>
        <DiscountsQueryList items={discountsFiltered}>
          {(discount) => <AddDiscountButton discount={discount} />}
        </DiscountsQueryList>
      </DiscountsQuery>
    </FlexBox>
  );
};

const DiscountsQueryView: React.FC = () => (
  <DiscountsQueryProvider>
    <DiscountsQueryContent />
  </DiscountsQueryProvider>
);

export default DiscountsQueryView;
